import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntro from "./HeaderIntro";
import NewsLetter from "./NewsLetter";
export class GstAdvisory extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
        <div className="container">
          <div class="container-fluid" data-aos="fade-up">
            

            <div class="section-header">
              <h3>GST Advisory</h3>
              <p>   The scope and requirements of GST law are complex, voluminous
                and come with a lot of grey areas. We, at ClipTax aim to make
                GST ‘simple and easy to implement’ .</p>
            </div>
            
          </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default GstAdvisory;
